import {
  AdditiveBlending,
  BackSide,
  Mesh,
  ShaderMaterial,
  SphereGeometry,
  Vector3,
} from "three";

import atmosphereVert from "./shaders/atmosphere.vert.glsl?raw";
import atmosphereFrag from "./shaders/atmosphere.frag.glsl?raw";
import { ATMOSPHERE_RADIUS } from "./constants";

export interface AtmosphereMesh {
  mesh: Mesh;
  setSunDirection(v: Vector3): void;
  setTheme(t: number): void;
  dispose(): void;
}

export function createAtmosphere(): AtmosphereMesh {
  const geometry = new SphereGeometry(ATMOSPHERE_RADIUS, 96, 72);
  const material = new ShaderMaterial({
    vertexShader: atmosphereVert,
    fragmentShader: atmosphereFrag,
    uniforms: {
      uSunDir: { value: new Vector3(1, 0, 0) },
      uTheme: { value: 0 },
    },
    blending: AdditiveBlending,
    side: BackSide,
    transparent: true,
    depthWrite: false,
  });

  const mesh = new Mesh(geometry, material);
  mesh.renderOrder = 1;

  return {
    mesh,
    setSunDirection(v) {
      material.uniforms.uSunDir.value.copy(v).normalize();
    },
    setTheme(t) {
      material.uniforms.uTheme.value = t;
    },
    dispose() {
      geometry.dispose();
      material.dispose();
    },
  };
}
